// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__VsrKJ","footer":"Form_footer__17XIe"};